import { type GetHookResponse } from '../hooks'
import { eventsKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  HOUR,
  CURRENT_VERSION,
  type CalendarEventDataWithDetails,
  type CalendarEventListInput,
  type CalendarEventListSuccess,
} from '@terros/common'

export function useCalendarEvents(
  input: CalendarEventListInput,
  enabled = true
): GetHookResponse<CalendarEventDataWithDetails[]> {
  return useTantalimQuery<CalendarEventListInput, CalendarEventListSuccess, CalendarEventDataWithDetails[]>({
    url: '/calendar/event/list',
    queryKey: eventsKey(input),
    input: {
      ...input,
      version: CURRENT_VERSION,
    },
    convertResponse: (data) => data.events,
    options: {
      retry: false,
      gcTime: HOUR,
      staleTime: HOUR,
      enabled,
    },
  })
}
